import withProtectedRoute from "src/features/auth/components/withProtectedRoute";
import { ORGANIZATION_CRUD_GROUP } from "src/features/groups/groups";
import EmployeeBulkCreateForm from "../components/EmployeeBulkCreateForm";

export default withProtectedRoute(
  EmployeeBulkCreateForm,
  "/dashboard",
  ORGANIZATION_CRUD_GROUP
);
